/* istanbul ignore file */
export enum ExportFormatType {
  printablePDF = "printablePDF",
  calendarSpreadsheet = "calendarSpreadsheet"
}
